import { render, staticRenderFns } from "./FooterCorporate.vue?vue&type=template&id=467fee0e&scoped=true"
import script from "./FooterCorporate.vue?vue&type=script&lang=js"
export * from "./FooterCorporate.vue?vue&type=script&lang=js"
import style0 from "./css/footer.css?vue&type=style&index=0&id=467fee0e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467fee0e",
  null
  
)

export default component.exports